import Cookies from 'js-cookie';
import { authChange } from '~/utils/authChange';

const TOKEN_KEY = 'userToken';

export class AuthTokenStorage {
  private authToken?: string;

  public setAuthToken = (token?: string): void => {
    this.authToken = token;
    if (this.authToken) {
      Cookies.set(TOKEN_KEY, this.authToken, { expires: 7 });
      authChange();
    }
  };

  public clearAuthToken = (): void => {
    this.authToken = undefined;
    Cookies.remove(TOKEN_KEY);
    authChange();
  };

  public getAuthToken = (): string | undefined => {
    if (!this.authToken) {
      this.authToken = Cookies.get(TOKEN_KEY);
    }
    return this.authToken;
  };
}

export const authTokenStorage = new AuthTokenStorage();
